// src/apiservice.js

const API_BASE = "https://www.maapranaam.co.in".replace(/\/$/, "");

/**
 * POST: Contact Enquiry
 * @param {Object} payload
 * @returns {Promise<Object>}
 */
async function sendContactEnquiry(payload) {
  const res = await fetch(`${API_BASE}/api/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || !data?.success) {
    throw new Error(data?.message || "Something went wrong. Please try again.");
  }

  return data;
}

/**
 * POST: Career Application (multipart/form-data)
 * @param {FormData} formData
 * @returns {Promise<Object>}
 */
async function submitCareerApplication(formData) {
  const res = await fetch(`${API_BASE}/api/career`, {
    method: "POST",
    body: formData,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || !data?.success) {
    throw new Error(data?.message || "Failed to submit application");
  }

  return data;
}

export default {
  sendContactEnquiry,
  submitCareerApplication,
};
